
class ConnectingGroupArgs {
    // Connecting shape from one point on a shape to another
    // using groups with different parameters
    //
    //// Size adjustments - if you want the arc size scaling to 
    //   be different than the groupSize values (multiplied by that)
    //
    // arcAdjust  - Arr[Number] {2} Normally the arc will draw full size
    //              but you may want to configure this.
    //
    //// Repeat adjustments for even counts TODO - 
    //
    // evenFull   - default False. Determines if even counts should attempt
    //              to cover the whole circle, because they 
    //              cause overlap problems in most cases.
    //
    //// Randomization arguments
    // arcChangeRepeat - n x 2 - repeat some sort of grow/shrink of the arcs
    //
    //// Group variables - used to draw discrete groups 
    //   with changes applied between group draws
    //
    // groups      - Array of number. Only apply the various attenutations
    //               after a group of specified size each time. 
    //               Uses an array so the size can change
    //
    // groupGaps    - Array of number. Resets the gap between the end points
    //               to this value after each groupSize.
    //               Should only be used with groupSize, otherwise it
    //               won't be applied.  
    // 
    // groupArc   - 2D Array of numbers used to reconfigure the arc 
    //              size for each group
    // groupSize  - 2D Array of numbers for the connecting shape length
    //
    // groupOffset - Offset the start point for the group by this amount,
    //               otherwise they start at an auto-calculated point
    //
    //// Other args -
    //   connectPoints - use straight lines instead of trying to use curves.
    //

    constructor(
    ) {
        this.connectPoints = false
        this.arcAdjust = [1, 1]
        this.arcChangeRepeat = [[1, 1]]

        this.groups = []
        this.groupSizes = []
        this.groupArcs = []
        this.groupGaps = []
        this.groupOffsets = []
    }

    // Setters
    setArcAdjust(adjust) {
        this.arcAdjust = adjust
        return this
    }

    setArcChangeRepeat(repeats) {
        this.arcChangeRepeat = repeats
        return this
    }

    setConnectPoints(connect) {
        this.connectPoints = connect
        return this
    }

    setGroups(groups) {
        this.groups = groups
        return this
    }

    setGroupGaps(groupGaps) {
        this.groupGaps = groupGaps
        return this
    }

    setGroupOffsets(groupOffsets) {
        this.groupOffsets = groupOffsets
        return this
    }

    setGroupArcs(groupArcs) {
        this.groupArcs = groupArcs
        return this
    }

    setGroupSizes(groupSizes) {
        this.groupSizes = groupSizes
        return this
    }

    // Getters
    getGroups() {
        return this.groups.slice(0)
    }

    getGroupGaps() {
        return this.groupGaps.slice(0)
    }

    getGroupOffsets() {
        return this.groupOffsets.slice(0)
    }

    getGroupArcs() {
        return this.groupArcs.slice(0)
    }

    getGroupSizes() {
        return this.groupSizes.slice(0)
    }

}

export { ConnectingGroupArgs }
